﻿/**
 * Delta Diesel Parts â€” Homepage JS
 * Mobile drawer, header scroll shadow, body class for template detection
 */
(function () {
  'use strict';

  /* â”€â”€ Mobile Drawer â”€â”€ */
  var btn = document.getElementById('ddp-hamburger');
  var overlay = document.getElementById('ddp-mob-overlay');
  var closeBtn = document.getElementById('ddp-mob-close');
  var searchBtn = document.getElementById('ddp-mob-search-toggle');
  var lastTrigger = null;

  function openMenu(trigger, focusSearch) {
    if (!btn || !overlay) return;
    lastTrigger = trigger || btn;
    btn.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
    if (searchBtn) searchBtn.setAttribute('aria-expanded', 'true');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (focusSearch) {
      var input = overlay.querySelector('.mob-search input[type="search"]');
      /* Wait for the drawer transition so focus lands on a visible field */
      if (input) window.setTimeout(function () { input.focus(); }, 320);
    }
  }

  function closeMenu() {
    if (!btn || !overlay) return;
    var wasOpen = overlay.classList.contains('open');
    btn.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');
    if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    if (wasOpen && lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  if (btn) btn.addEventListener('click', function () { openMenu(btn, false); });
  if (searchBtn) searchBtn.addEventListener('click', function () { openMenu(searchBtn, true); });
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) {
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeMenu();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  var mobNavLinks = document.querySelectorAll('.mob-nav a, .mob-footer-actions a');
  mobNavLinks.forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  /* â”€â”€ Header shadow on scroll â”€â”€ */
  var hdr = document.querySelector('.ddp-header');
  if (hdr) {
    window.addEventListener(
      'scroll',
      function () {
        hdr.style.boxShadow =
          window.scrollY > 10
            ? '0 2px 24px rgba(0,0,0,.12)'
            : '0 2px 16px rgba(0,0,0,.07)';
      },
      { passive: true }
    );
  }
})();

